import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["peopleSection", "people", "addPerson", "personTemplate", "result", "notice", "holderBirthdate", "holderAge", "holderAgeHelp", "holderBirthdateError"]
  static values = { today: String }

  connect() {
    this.sequence = 0
    this.form = this.element.querySelector("form[data-controller~='payment-fields']")
    this.syncProduct()
    this.syncHolderAge()
  }

  syncProduct() {
    const product = this.form.querySelector("input[name='direct_sale[product_id]']:checked")
    this.active = product?.dataset.productType === "funerary_plan"
    this.peopleSectionTarget.hidden = !this.active
    this.peopleSectionTarget.disabled = !this.active
    this.addPersonTarget.hidden = product?.dataset.allowsBeneficiaries === "false"
  }

  changed(event) {
    if (!this.form.contains(event.target)) return
    const name = event.target.name || ""
    const changesQuote = /^direct_sale\[(product_id|sale_type|discount_amount|adhesion_installments|customer_birthdate|beneficiaries_attributes|direct_sale_adicionals_attributes)\]/.test(name)
    const changesReceipt = /^direct_sale\[(down_payment_method|down_payment_installments|down_payment_date|contract_first_due_date|down_payment_tenders)\]/.test(name)
    const changesReceiptMode = event.target.matches('[data-payment-tenders-target~="toggle"]')
    // Shared cemetery controls and search widgets also emit events on load.
    // Only the inputs used by the funeral quote/receipt can invalidate it.
    if (!changesQuote && !changesReceipt && !changesReceiptMode) return
    if (changesQuote) {
      delete this.element.dataset.quoteGrossCents
    }
    if (event.target.name === "direct_sale[product_id]") this.syncProduct()
    if (event.target === this.holderBirthdateTarget) this.syncHolderAge()
    this.invalidate()
    const pricing = this.application.getControllerForElementAndIdentifier(this.form, "payment-fields")
    if (this.active) pricing?.calculatePricePreview()
  }

  invalidate() {
    if (this.hasResultTarget) {
      this.resultTarget.hidden = true
      this.resultTarget.querySelectorAll("button, input").forEach(input => { input.disabled = true })
    }
    if (this.hasNoticeTarget) this.noticeTarget.hidden = false
  }

  syncHolderAge() {
    if (!this.hasHolderBirthdateTarget) return
    const input = this.holderBirthdateTarget
    const raw = input.value
    input.setCustomValidity("")
    input.removeAttribute("aria-invalid")
    this.holderBirthdateErrorTarget.hidden = true
    this.holderAgeTarget.readOnly = !!raw
    if (!raw) {
      this.holderAgeHelpTarget.textContent = "Se não souber a data, informe somente a idade para simular."
      return
    }
    const [year, month, day] = raw.split("-").map(Number)
    const date = new Date(Date.UTC(year, month - 1, day))
    const valid = /^\d{4}-\d{2}-\d{2}$/.test(raw) && date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
    if (!valid || year < 1900 || raw > this.todayValue) {
      const message = "Informe uma data válida, entre 1900 e hoje."
      input.setCustomValidity(message)
      input.setAttribute("aria-invalid", "true")
      this.holderBirthdateErrorTarget.textContent = message
      this.holderBirthdateErrorTarget.hidden = false
      this.holderAgeTarget.value = ""
      return
    }
    const [todayYear, todayMonth, todayDay] = this.todayValue.split("-").map(Number)
    const beforeBirthday = todayMonth < month || (todayMonth === month && todayDay < day)
    this.holderAgeTarget.value = String(todayYear - year - (beforeBirthday ? 1 : 0))
    this.holderAgeHelpTarget.textContent = "Idade calculada pela data de nascimento."
  }

  additionalClicked(event) {
    if (!event.target.closest("button[data-action*='adicionals#']")) return
    delete this.element.dataset.quoteGrossCents
    this.invalidate()
  }

  addPerson() {
    delete this.element.dataset.quoteGrossCents
    this.peopleTarget.insertAdjacentHTML("beforeend", this.personTemplateTarget.innerHTML.replaceAll("NEW_PERSON", `inline_${++this.sequence}`))
    this.invalidate()
    this.peopleTarget.lastElementChild.querySelector("select").focus()
  }

  removePerson(event) {
    delete this.element.dataset.quoteGrossCents
    const row = event.target.closest("[data-person-row]")
    row.querySelector("[data-destroy]").value = "1"
    row.hidden = true
    row.querySelectorAll("[required]").forEach(input => { input.required = false })
    this.changed({ target: row.querySelector("[data-destroy]") })
  }
}
